import React, { useEffect, useState } from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import cardsBg from "assets/images/common/others/cardsBg.png";
import cardProfilePic from "assets/images/common/others/cardProfilePic.png";
import { useNavigate } from "react-router-dom";
import useUsers from "containers/user-management/useHooks";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";
import DataNotFound from "components/particles/table/data-not-found";
import { useSelector } from "react-redux";
import { siteRoutes } from "utils/helpers/enums/routes.enum";
import useUtils from "hooks/useUtils";

interface Props {
  attendeeId: number;
}

const Minors = ({ attendeeId }: Props) => {
  console.log(attendeeId);
  const navigate = useNavigate();
  const { getMinorById } = useUsers();
  const { isLoading } = useSelector((state: any) => state.sharedReducer);
  const [data, setData] = useState<any[]>([]);
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  attendeeId = attendeeId || params?.id;
  useEffect(() => {
    getMinorById({ attendeeId: attendeeId }, setData);
  }, [attendeeId]);

  console.log(data);
  const goToMinorDetail = (id: number) => {
    navigate(`${siteRoutes.viewMinors}?id=${id}`);
  };

  return (
    <div>
      <div className="flex flex-wrap items-center gap-4 py-5">
        {data?.map((item) => (
          <div
            key={item.id}
            onClick={() => goToMinorDetail(item?.id)}
            className="flex flex-col items-center justify-center p-4  min-w-[235px] min-h-[259px] cursor-pointer bg-cover bg-center bg-no-repeat rounded-3xl"
            style={{ backgroundImage: `url(${cardsBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                className="w-[100px] h-[100px] object-cover rounded-full"
                src={
                  item?.profilePic
                    ? concatPathWithBackendUrl(
                        item?.profilePic?.fileDownloadUri
                      )
                    : editProfilePicUser
                }
                alt={item?.firstName}
              />
            </div>
            <span className="text-base font-semibold my-2 text-primaryText">
              {item?.firstName} {item?.lastName}
            </span>
            <span className="text-sm  text-primaryText">{item?.username}</span>
          </div>
        ))}
      </div>

      <div className="mt-10 text-9xl">
        <DataNotFound show={!isLoading && !data.length} />
      </div>
    </div>
  );
};

export default Minors;
